import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';
import Button from 'components/Button';
import Title from 'components/Title';
import Message from "../Message";

import styles from './Subscription.module.css';

const cx = classNames.bind(styles);

const width = window.outerWidth || window.innerWidth;
const isMobile = width <= 600;

export default class Subscription extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    isLoading: PropTypes.bool,
    submitBtn: PropTypes.string,
    activateBtn: PropTypes.string,
    cancelBtn: PropTypes.string,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    isAfterRestore: PropTypes.bool,
    isSessionOver: PropTypes.bool,
    textError: PropTypes.string,
    isActivating: PropTypes.bool
  }

  static defaultProps = {
    children: null,
    isLoading: false,
    submitBtn: null,
    activateBtn: null,
    cancelBtn: null,
    onCancel: () => { },
    onSubmit: () => { },
    onActivate: () => { },
    textError: null,
    isAfterRestore: false,
    isSessionOver: false,
  }

  render() {
    const {
      submitBtn,
      cancelBtn,
      activateBtn,
      onSubmit,
      onCancel,
      onActivate,
      isLoading,
      isAfterRestore,
      isSessionOver,
      textError,
      isActivating
    } = this.props;

    return (
      <form className={cx('subscription', {subscription_afterRestore: isAfterRestore, subscription_sessionOver: isSessionOver})} onSubmit={onSubmit}>
        {isAfterRestore && isMobile && <div></div>}
        <div className={cx('title')}>
          <Title size='small' isAfterRestore={isAfterRestore}>
            {this.props.children}
          </Title>
        </div>

        {
          textError &&
          <div className={cx('error')}>
            <Message text={textError} />
          </div>
        }

        {(submitBtn || cancelBtn) &&
          <div className={cx('buttons', {buttons_afterRestore: isAfterRestore})}>
            {submitBtn &&
              <div className={cx('button')}>
                <Button
                  isLoading={isLoading}
                  disabled={isLoading}
                  type='submit'
                  upper
                  bordered
                  block
                >
                  {submitBtn}
                </Button>
              </div>
            }
            {cancelBtn &&
              <div className={cx('button', {button_afterRestore: isAfterRestore})}>
                <Button
                  onClick={onCancel}
                  upper={!isAfterRestore}
                  disabled={isActivating || false}
                  bordered
                  block
                  customClass={isAfterRestore && 'button--registration'}
                >
                  {cancelBtn}
                </Button>
              </div>
            }
            {activateBtn &&
              <div className={cx('button')}>
                <Button
                  isLoading={isActivating}
                  disabled={isActivating}
                  onClick={onActivate}
                  upper={true}
                  bordered
                  block
                  title={"Нажатием этой кнопки вы создадите свой собственный аккаунт с тем же логином(почтой) и паролем. Пациенты, а так же остальной контент, созданный вами, перенесется в ваш новый аккаунт"}
                >
                  {activateBtn}
                </Button>
              </div>
            }
          </div>
        }
      </form>
    );
  }
}
